import { Avatar, ButtonProps } from "@material-ui/core";
import React, { ReactElement } from "react";
import { FaRobot } from "react-icons/fa";
import ctaButtonConfig, { AlmeCtaButtonConfig } from "../../ResponseActions/AlmeCtaButton/AlmeCtaButtonConfig";
import changeTenantConfirmationConfig, { ChangeTenantConfirmationConfig } from "../../ResponseActions/ChangeTenantConfirmation/ChangeTenantConfirmationConfig";
import surveyConfig, { AlmeSurveyConfig } from "../../ResponseActions/AlmeSurvey/AlmeSurveyConfig";

interface IvaResponseConfig extends AlmeCtaButtonConfig, AlmeSurveyConfig, ChangeTenantConfirmationConfig {
    shouldAutoNav?: boolean;
    ivaIcon?: ReactElement;
    styles: {
        displayLink: {
            color: ButtonProps['color'];
            variant: ButtonProps['variant'];
        };
        navUrl: {
            color: ButtonProps['color'];
            variant: ButtonProps['variant'];
        };
    };
}

export interface AlmeIvaResponseConfig {
    ivaResponse: IvaResponseConfig;
}

/**
 * This is the baseline response config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
 */
const defaultConfig: AlmeIvaResponseConfig = {
    ivaResponse: {
        ...ctaButtonConfig,
        ...changeTenantConfirmationConfig,
        ...surveyConfig,
        ivaIcon: (
            <Avatar>
                <FaRobot />
            </Avatar>
        ),
        styles: {
            displayLink: {
                color: 'primary' as const,
                variant: 'outlined' as const,
            },
            navUrl: {
                color: 'primary' as const,
                variant: 'contained' as const,
            },
        },
    },
};

export default defaultConfig;